async function getNotifications() {
  const url = `${process.env.REACT_APP_API_URL}/Notification`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
    });

    if (response.status === 401) {
      // Optional: let AuthContext know so it can logout
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch notifications');
    throw error;
  }
}

async function uploadNotification(fileName, title, description, file) {
  const url = `${process.env.REACT_APP_API_URL}/Notification/AddNotification`;
  const formData = new FormData();
  formData.append('fileName', fileName);
  formData.append('title', title);
  formData.append('description', description);
  formData.append('file', file);

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData
    });

    if (response.status === 401) {
      // Optional: let AuthContext know so it can logout
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('There was an error uploading the notification!');
    throw error;
  }
}

export default { getNotifications, uploadNotification };
